import classNames from 'classnames';
import contractPrintUtils, { ContractStyleType } from '../utils';

const ContractTitle = ({
  storeId,
  contractStyleType,
}: {
  storeId: number;
  contractStyleType: ContractStyleType;
}) => {
  return (
    <div
      className={classNames(
        'px-1 mb-12 shrink-0',
        contractStyleType === 'white'
          ? 'bg-white text-black border border-black'
          : 'bg-black text-white',
      )}
      // https://blog.csdn.net/weixin_45122120/article/details/103269099
      // https://developer.mozilla.org/zh-CN/docs/Web/CSS/print-color-adjust
      style={{ printColorAdjust: 'exact' }}
    >
      {contractPrintUtils.getStoreName({ storeId }).toUpperCase()}
    </div>
  );
};

export default ContractTitle;
